import { render } from "./SupportDetails.vue?vue&type=template&id=6667b5c5"
import script from "./SupportDetails.vue?vue&type=script&lang=js"
export * from "./SupportDetails.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__